<h4 class="mobi-ui-font-size-400">
  <span class="block font-bold mobi-ui-font-size-50 mb-2 text-black">
    {{ 'our' | texts: { context: 'primcalc', default: 'Unsere' } }}
  </span>
  {{ 'recommendation' | texts: { context: 'primcalc', default: 'Empfehlung' } }}
</h4>
<div class="mobi-ui-text-center mobi-ui-padding-b-md mobi-ui-margin-t-lg">
  <div class="mobi-ui-price-major is-center">
    <span class="mobi-ui-price-unit-major">CHF</span>
    <span class="mobi-ui-price-value-major">{{
      formatNumber(result.amount, '0,0.00')
    }}</span>
  </div>
  <span>
    {{ 'ins_sum' | texts: { context: 'primcalc', default: 'Versicherungssumme' } }}*
  </span>
</div>
<div class="flex justify-center">
  <a [href]="result.calc_url" target="_blank" class="mobi-ui-btn-major">
    {{
      'complete_now'
        | texts: { context: 'primcalc', default: 'Jetzt online abschliessen' }
    }}
  </a>
</div>
